var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Wallet_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2878 7.68332H20.1663C20.1663 4.56921 18.3004 2.75 15.1389 2.75H6.86042C3.69893 2.75 1.83301 4.56921 1.83301 7.6436V14.3564C1.83301 17.4308 3.69893 19.25 6.86042 19.25H15.1389C18.3004 19.25 20.1663 17.4308 20.1663 14.3564V14.0704H16.2878C14.4878 14.0704 13.0286 12.6477 13.0286 10.8928C13.0286 9.13778 14.4878 7.71509 16.2878 7.71509V7.68332ZM16.2882 9.04883H19.4823C19.8603 9.04883 20.1667 9.34759 20.1667 9.71614V12.0358C20.1623 12.4026 19.8584 12.6988 19.4823 12.7031H16.3615C15.4503 12.7151 14.6534 12.1068 14.4467 11.2414C14.3432 10.7042 14.4885 10.1499 14.8437 9.72698C15.1989 9.30408 15.7276 9.05585 16.2882 9.04883ZM16.4263 11.4875H16.7278C17.1148 11.4875 17.4285 11.1817 17.4285 10.8043C17.4285 10.427 17.1148 10.1211 16.7278 10.1211H16.4263C16.2412 10.119 16.063 10.1892 15.9313 10.3161C15.7997 10.443 15.7256 10.6159 15.7256 10.7964C15.7256 11.175 16.038 11.4832 16.4263 11.4875ZM6.17633 7.6828H11.3504C11.7374 7.6828 12.0511 7.37692 12.0511 6.9996C12.0511 6.62228 11.7374 6.31641 11.3504 6.31641H6.17633C5.79248 6.31638 5.48005 6.61745 5.47559 6.99166C5.47556 7.37028 5.788 7.67845 6.17633 7.6828Z",
    fill: "#B52126"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.3111435f1246e423f9da8783798bf109.svg";
export { ForwardRef as ReactComponent };